import { useState, useEffect } from 'react';
import { getDefectTypes } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useDefectTypes = (showAll = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [defectTypes, setDefectTypes] = useState([]);

  useEffect(() => {
    const loadDefectTypes = async () => {
      try {
        const types = await getDefectTypes();
        if (types?.status) {
          const fetchedTypes = types.data || [];
          // Conditionally add 'Show All' if types exist and showAll is true
          const updatedTypes = (showAll && fetchedTypes.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedTypes]
            : fetchedTypes;
          setDefectTypes(updatedTypes);
        }
      } catch (error) {
        dispatch(showError(t('message.failedToLoadDefectTypes')));
        setDefectTypes([]); // Reset on error
      }
    };
    loadDefectTypes();
  }, [showAll, t]);

  return defectTypes;
}; 
